import React, { useMemo, useState } from 'react';

import styles from './styles';
import { Container, Grid, makeStyles, Paper } from '@material-ui/core';
import { injectIntl } from 'react-intl';
import Requests from './components/Requests';
import FiltersMenu from './components/FiltersMenu';
import { useSelector } from 'react-redux';
import { INITIAL_STATUS_FILTER } from 'app/config/status';
import { SYSTEM_DOC_TYPES, USER_SECTORS } from 'app/utils/constants';
import ManualButton from 'app/components/ManualButton';
import { usePersistentFilters } from '../Lines/hooks/usePersistentFilters';

const useStyles = makeStyles(styles);

function InBox(props) {
  const classes = useStyles();

  const [loading, setLoading] = useState(true);

  const user = useSelector(state => state.auth.user);

  const manualType = useMemo(() => {
    if (user.setores) {
      const userSectors = user.setores.map(sector => sector.cdOrgaoSetor);
      if (userSectors.includes(USER_SECTORS.DPE_DPSE)) {
        return SYSTEM_DOC_TYPES.EMPRESA.key;
      } else if (userSectors.includes(USER_SECTORS.DQS_DFIS_COVIT)) {
        return SYSTEM_DOC_TYPES.VEICULO.key;
      } else if (userSectors.includes(USER_SECTORS.DQS_DFIS_GEFIC)) {
        return SYSTEM_DOC_TYPES.LICENCA.key;
      } else if (userSectors.includes(USER_SECTORS.DQS_DPLO)) {
        return SYSTEM_DOC_TYPES.LINHAS.key;
      }
    }
    return SYSTEM_DOC_TYPES.EXTERNO.key;
  }, [user.setores]);

  const initialFilters = useMemo(() => {
    return {
      campoOrdenacao: 'dtCadastro',
      direcaoOrdenacao: 'desc',
      page: 0,
      situacoes: INITIAL_STATUS_FILTER,
      usuarios: [
        {
          cdUsuario: user.username,
          nmUsuario: user.nmusuario,
          boAtivo: user.boAtivo,
        },
      ],
    };

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const [filters, setFilters] = usePersistentFilters(initialFilters, 'inbox-filters');


  return (
    <>
      <ManualButton
        rest={{
          type: manualType,
        }}
        color={'primary'}
      />
      <Container>
        <Grid container spacing={3}>
          <Grid item xs={12} sm={4} md={3}>
            <Paper elevation={0} variant="outlined" square className={classes.paper}>
              <FiltersMenu
                filters={filters}
                setFilters={setFilters}
                loading={loading}
                setLoading={setLoading}
              />
            </Paper>
          </Grid>
          <Grid item xs={12} sm={8} md={9}>
            <Paper elevation={0} variant="outlined" square className={classes.paperContent}>
              <Requests
                filters={filters}
                setFilters={setFilters}
                loading={loading}
                setLoading={setLoading}
              />
            </Paper>
          </Grid>
        </Grid>
      </Container>
    </>
  );
}

export default injectIntl(InBox);
